import FaqPage from "../pages/FaqPage";

export const faqPageRoutes = [{
  path: "contents/faq",
  name: "سوالات متداول",
  component: FaqPage
},
];
export default faqPageRoutes;
